module.exports = __webpack_public_path__ + "img/open.fa10907c.svg";